import { lazyLoadMedia } from './utils/lazyload';
import { initSwiper } from './library/swiper';
import { initFancybox } from './library/fancybox';
import { initNotyf } from './library/notification';
import { initializeTabs } from './library/tabs';
import { initTooltip } from './library/typpy';
import { initMarquee } from './library/marquee';
import { modal } from './library/modal';
import { reviewMore } from './main/initReview';
import { initAccordion } from './library/accordion';
import {initHeader} from "./main/initHeader";
import {initSidebarFocus} from "./main/initSidebarFocus";
import {initSearchSidebarService} from "./main/initSearchSidebarService";
import {initAnchor} from "./main/initAnchor";
import {initDoctorsList} from "./main/initDoctors";
import {initFullWidthSwiper} from "./main/initFullWidthSwiper";
import {initEducation} from "./main/initEducation";
import {intiSliderGutter} from "./main/intiSliderGutter";
import 'simplebar';
import {initProgram} from "./main/initProgram";
import {initServiceShow} from "./main/initServiceShow";
import {inputFilled} from "./main/inputFilled";
import {initPhoneMask} from "./main/initPhoneMask";
import {initFileResume} from "./main/initFileResume";
import {initLinksResume} from "./main/initLinksResume";
import {initArticle} from "./main/initArticle";
import {initAnimProgram} from "./main/initAnimProgram";
import {initWorks} from "./main/initWorks";
import {flatPickers} from "./library/flatpicker";
import {initFormPopup} from "./main/initFormPopup";
import {initFile} from "./main/initFile";
import 'dragscroll';
import {initVideoHoverHome} from "./main/initVideoHoverHome";

import {initVideoSliderReviews} from "./main/initVideoSliderReviews";
import {snow} from "./main/snow";
import {select} from "./library/select";
import {initCuratorForm} from "./main/initCuratorForm";
import {initTooltips} from "./main/initTooltips";
import {initAccordionProgram} from "./main/initAccordionProgram";
import { initCallbackWidget } from './main/initCallbackWidget';

document.addEventListener('DOMContentLoaded', () => {
    lazyLoadMedia();
    initHeader();
    initAccordionProgram();
    initTooltips();
    initSidebarFocus();
    initSearchSidebarService();
    initDoctorsList();
    initAccordion();
    initCallbackWidget('#callbackWidget', {});
    initSwiper();
    initFancybox();
    initFullWidthSwiper();
    initEducation();
    intiSliderGutter();
    initProgram();
    initServiceShow();
    inputFilled();
    initPhoneMask();
    initFileResume();
    initLinksResume();
    initArticle();
    initAnimProgram();
    initWorks();
    flatPickers();
    initFormPopup();
    initFile();
    initVideoHoverHome();
    initNotyf();
    select();
    initCuratorForm();
    initVideoSliderReviews();
    // initializeTabs();
    // initTooltip();
    initMarquee();
    modal;
    reviewMore;
    setTimeout(function (){
        initAnchor();
    }, 500)

});
